/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useEffect, useContext } from 'react'
import { dateCol, intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo, getEnvConfig, getPermitActions } from 'core'
import {
  getUnitNameMap,
  getUtilityUnitsMap,
  getCompanyNameMap,
  getUserCompany,
} from 'core/selectors'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getMisoMaDataImport,
  getMisoUnitMappingInfo,
  importMisoMaDataImport,
} from 'api/pgads.js'
import { message, Select, DatePicker, Button, Input, Tabs } from 'antd'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'

import R from 'ramda'
import { rowHeaderRender } from 'core/utils'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
const title = 'Import MA Data (MISO)'
const MisoImportMaData = ({ unitNameMap, apiTargetInfo }) => {
  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const [activeKey, setActiveKey] = useState('dataSet1')
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [maDataSet1data, setMaDataSet1Data] = useState([])
  const [maDataSet2data, setMaDataSet2Data] = useState([])
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const [units, setUnits] = useState([])
  const [elementNameToUnitIdMap, setElementNameToUnitIdMap] = useState({})
  const [selectedUnits, setSelectedUnits] = useState('')

  useEffect(
    _ => {
      getMisoUnitMappingInfo(apiTargetInfo).fork(setError, data => {
        setUnits(data)

        const transformedOptions = R.compose(
          R.fromPairs,
          R.map(d => [d.elementName, d.unitId])
        )(data)

        setElementNameToUnitIdMap(transformedOptions)
      })
    },
    [apiTargetInfo, setError]
  )

  const retrieve = () => {
    if (selectedUnits.length === 0) {
      message.warning('Please,Select location')
      return
    }
    setSpinning(true)
    getMisoMaDataImport(apiTargetInfo)(selectedDate, selectedUnits).fork(
      setError,
      data => {
        setSpinning(false)

        setMaDataSet1Data(data.maDataSet1)
        setMaDataSet2Data(data.maDataSet2)
        setActiveKey('dataSet1')
      }
    )
  }

  const importData = () => {
    message.info('Data is importing, please check after some time!')
    // setSpinning(true)
    importMisoMaDataImport(apiTargetInfo)(selectedDate).fork(setError, () => {
      // message.success('Data imported successfully!')
      // setSpinning(false)
      // retrieve()
    })
  }

  const maDataSet1Headers = [
    strCol({
      ident: 'Unit',
      display: 'Unit',
      width: 350,
      dataGetter: ({ rowData }) => {
        return unitNameMap[elementNameToUnitIdMap[rowData.elementName]]
      },
    }),
    strCol({
      ident: 'elementName',
      display: 'Element Name',
      width: 350,
      isKey: true,
    }),
    dateCol({
      ident: 'transdate',
      display: 'Date',
      width: 150,
      isKey: true,
    }),
    numCol({
      ident: 'hotStupcost',
      display: 'Hot Startup Cost',
      width: 100,
    }),
    numCol({
      ident: 'interStupCost',
      display: 'Inter Startup Cost',
      width: 100,
    }),
    numCol({
      ident: 'coldStupCost',
      display: 'Cold Startup Cost',
      width: 100,
    }),
    numCol({
      ident: 'ecoMinmw',
      display: 'Eco Minmw',
      width: 100,
    }),
    numCol({
      ident: 'ecoMaxmw',
      display: 'Eco Maxmw',
      width: 100,
    }),
    numCol({
      ident: 'emerMinmw',
      display: 'Emer Minmw',
      width: 100,
    }),
    numCol({
      ident: 'emerMaxmw',
      display: 'Emer Maxmw',
      width: 100,
    }),
    numCol({
      ident: 'noloadcost',
      display: 'Noloadcost',
      width: 100,
    }),
    numCol({
      ident: 'coldstartupTime',
      display: 'Coldstartup Time',
      width: 100,
    }),
    numCol({
      ident: 'interstartupTime',
      display: 'Interstartup Time',
      width: 100,
    }),
    numCol({
      ident: 'hotstartupTime',
      display: 'Hotstartup Time',
      width: 100,
    }),
    numCol({
      ident: 'minRuntime',
      display: 'Min Runtime',
      width: 100,
    }),
    numCol({
      ident: 'maxRuntime',
      display: 'Max Runtime',
      width: 100,
    }),
    numCol({
      ident: 'minDowntime',
      display: 'Min Downtime',
      width: 100,
    }),
    numCol({
      ident: 'hottocoldTime',
      display: 'Hottocold Time',
      width: 100,
    }),
    numCol({
      ident: 'hottointerTime',
      display: 'Hottointer Time',
      width: 100,
    }),
    numCol({
      ident: 'maxDailyStarts',
      display: 'Max Daily Starts',
      width: 100,
    }),
    numCol({
      ident: 'seg1Price',
      display: 'Seg1 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg2Price',
      display: 'Seg2 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg3Price',
      display: 'Seg3 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg4Price',
      display: 'Seg4 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg5Price',
      display: 'Seg5 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg6Price',
      display: 'Seg6 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg7Price',
      display: 'Seg7 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg8Price',
      display: 'Seg8 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg9Price',
      display: 'Seg9 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg10Price',
      display: 'Seg10 Price',
      width: 100,
    }),
    numCol({
      ident: 'seg1Mw',
      display: 'Seg1 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg2Mw',
      display: 'Seg2 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg3Mw',
      display: 'Seg3 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg4Mw',
      display: 'Seg4 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg5Mw',
      display: 'Seg5 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg6Mw',
      display: 'Seg6 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg7Mw',
      display: 'Seg7 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg8Mw',
      display: 'Seg8 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg9Mw',
      display: 'Seg9 Mw',
      width: 100,
    }),
    numCol({
      ident: 'seg10Mw',
      display: 'Seg10 Mw',
      width: 100,
    }),
    // numCol({
    //   ident: 'fuelPrice',
    //   display: 'FuelPrice',
    //   width: 100,
    // }),
    modifierCol,
    modifiedDateCol,
  ]

  const maDataSet2Headers = [
    strCol({
      ident: 'Unit',
      display: 'Unit',
      width: 350,
      dataGetter: ({ rowData }) => {
        return unitNameMap[elementNameToUnitIdMap[rowData.elementName]]
      },
    }),
    strCol({
      ident: 'elementName',
      display: 'Element Name',
      isKey: true,
      width: 350,
    }),
    // strCol({
    //   ident: 'transdateGmt',
    //   display: 'TransdateGmt',
    //   width: 350,

    // }),
    dateCol({
      ident: 'transdate',
      display: 'Date',
      isKey: true,
      width: 150,
    }),
    intCol({
      ident: 'hour',
      display: 'Hour',
      isKey: true,
      width: 100,
    }),
    numCol({
      ident: 'daLmp',
      display: 'DA LMP',
      width: 100,
    }),
    numCol({
      ident: 'rtLmp',
      display: 'RT LMP',
      width: 100,
    }),
    numCol({
      ident: 'daAward',
      display: 'DA AWARD',
      width: 100,
    }),
    modifierCol,
    modifiedDateCol,
  ]

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          {title}
        </Title>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={retrieve}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>
        <Button
          Style={{ marginRight: '10px' }}
          onClick={importData}
          css={{ marginLeft: '10px' }}
          icon="thunderbolt"
          type="danger"
        >
          Import
        </Button>
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <Button
          Style={{ marginRight: '10px' }}
          // onClick={exportData}
          icon="export"
        >
          Export
        </Button>
      </CriteriaRow>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'auto',
            width: '100%',
          }}
        >
          <div
            style={{
              gridRow: '1',
            }}
          >
            <span>Select Locations: </span>
          </div>
          <div
            style={{
              gridRow: '2',
            }}
          >
            <Select
              mode="multiple"
              allowClear
              style={{
                width: '100%',
              }}
              placeholder="Please select locations"
              onChange={value => {
                setSelectedUnits(value)

                setMaDataSet1Data([])
                setMaDataSet2Data([])
                // setMaDataSet3Data([])
              }}
            >
              {units?.map((x, y) => (
                <Select.Option value={x.elementName} key={y}>
                  {x.pnodeId}-{unitNameMap[x.unitId]}-({x.elementName})
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={300}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Tabs activeKey={activeKey} onChange={setActiveKey}>
              <Tabs.TabPane
                title="MISO Data Set 1"
                key="dataSet1"
                tab="MISO Data Set 1"
              >
                <div style={{ height: height - 20, width: width }}>
                  <Grid
                    headerRowHeight={30}
                    height={height - 100}
                    width={width - 60}
                    headers={maDataSet1Headers}
                    data={maDataSet1data}
                    // fuzzyFilter={fuzzyFilter}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 60,
                      headerRowHeight: 60,
                    })}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane
                title="MISO Data Set 2"
                key="dataSet2"
                tab="MISO Data Set 2"
              >
                <div style={{ height: height, width: width }}>
                  <Grid
                    headerRowHeight={30}
                    height={height - 100}
                    width={width - 60}
                    headers={maDataSet2Headers}
                    data={maDataSet2data}
                    setData={setMaDataSet2Data}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 60,
                      headerRowHeight: 30,
                    })}
                    // fuzzyFilter={fuzzyFilter}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
  // utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  userCompany: getUserCompany(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(MisoImportMaData)
// export default MisoImportMaData
